import React from 'react';
import {ObjectPropertyDetails} from "../../../types/Object";
import {ShowMore} from "../../../common/show-more/ShowMore";
import {FieldKind} from "../../../types/GraphQlSchema";

type ScalarPropertyViewProps = {
  property: ObjectPropertyDetails
}

export default class ScalarPropertyView extends React.Component<ScalarPropertyViewProps> {

  static canHandle(property: ObjectPropertyDetails): boolean {
    return property.graphQlFieldRef.kind === FieldKind.SCALAR;
  }

  render() {
    const property = this.props.property;
    if (property.multi) {
      if (property.value.length < 2) {
        return `${property.value[0]}`;
      }
      return renderMultiScalar(property.value);
    }
    return `${property.value}`;
  }

}

function renderMultiScalar(values: any) {
  const scalars = values.map((value: any, index: number) => {
    return <li key={index}>{value}</li>;
  });
  return <ul><ShowMore elements={scalars}/></ul>;
}
